import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';

import { CHILDREN_PROPTYPES } from 'bento-ordering/base/constants/propTypes';
import { isMobileMedia } from 'bento-ordering/utils/media';

const useStyles = makeStyles(theme => ({
  wrapper: {
    opacity: ({ isVisible }) =>
      `${isVisible || isMobileMedia() ? 'inherit' : '0'}`,
    zIndex: ({ isVisible }) =>
      `${isVisible || isMobileMedia() ? 'inherit' : '-1'}`,
    position: ({ isVisible }) =>
      `${isVisible || isMobileMedia() ? 'inherit' : 'absolute'}`,
    padding: '0 10px',
    display: 'flex',
    justifyContent: ({ justifyContent }) => justifyContent,
    alignItems: 'center',
    '& .MuiSvgIcon-root': {
      fill: theme.palette.text.disabled
    },
    '@media (hover)': {
      '&:hover': {
        cursor: 'pointer',
        '& *': {
          fill: theme.palette.secondary.main,
          color: theme.palette.secondary.main
        }
      }
    },
    '&:first-child': {
      paddingLeft: ({ isInMoreSection }) => (isInMoreSection ? '10px' : '2px')
    },
    /**
     * This media query is use to adjust the padding on the first child
     * which is slightly off at a specific width
     */
    // eslint-disable-next-line no-useless-computed-key
    ['@media (max-width:1300px) and (min-width: 1255px)']: {
      '&:first-child': {
        paddingLeft: ({ isInMoreSection }) =>
          !isInMoreSection && window.navigator.userAgent.indexOf('Win') !== -1
            ? '10px'
            : '2px'
      }
    },
    [theme.breakpoints.down('md')]: {
      '&:first-child': {
        paddingLeft: ({ isInMoreSection }) => (isInMoreSection ? '8px' : '16px')
      }
    },
    [theme.breakpoints.down('sm')]: {
      color: 'blue',
      padding: '0 10px 0 8px',
      display: ({ hideOnMobile }) => `${hideOnMobile ? 'none' : 'flex'}`,
      justifyContent: 'flex-end',
      '& .MuiSvgIcon-root': {
        fill: theme.palette.secondary.main,
        display: 'flex',
        alignItems: 'center'
      }
    }
  }
}));

const MenuSectionsBarNavLinkWrapper = ({
  children,
  hideOnMobile,
  handleClick,
  dataTestId,
  paddingLeft,
  paddingRight,
  id,
  justifyContent,
  isInMoreSection,
  isVisible,
  onFocus
}) => {
  const classes = useStyles({
    hideOnMobile,
    paddingLeft,
    paddingRight,
    justifyContent,
    isInMoreSection,
    isVisible
  });
  return (
    <Box
      id={id}
      data-testid={dataTestId}
      onClick={handleClick}
      className={classes.wrapper}
      onFocus={onFocus}
    >
      {children}
    </Box>
  );
};

MenuSectionsBarNavLinkWrapper.defaultProps = {
  justifyContent: 'flex-end',
  isInMoreSection: false
};

MenuSectionsBarNavLinkWrapper.propTypes = {
  classes: PropTypes.shape({}),
  children: CHILDREN_PROPTYPES,
  hideOnMobile: PropTypes.bool,
  dataTestId: PropTypes.string,
  handleClick: PropTypes.func,
  paddingLeft: PropTypes.string,
  paddingRight: PropTypes.string,
  id: PropTypes.string,
  justifyContent: PropTypes.string,
  isInMoreSection: PropTypes.bool,
  isVisible: PropTypes.bool,
  onFocus: PropTypes.func
};

export default MenuSectionsBarNavLinkWrapper;
